module.exports = __webpack_public_path__ + "img/carMarker.f4a0aa83.svg";